import { getVideoId, getVideoUrl, VideoType } from '@/utils/vimeoVideoUtils';
import { AspectRatio } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { GameVideoProps } from './game-video.types';

export const GameVideo = ({
  title,
  videoUrl,
  videoType,
  autoplay = true,
  ...rest
}: PropsWithChildren<GameVideoProps>) => {
  const type = (videoType as VideoType) || VideoType.VIMEO;

  const videoId = getVideoId(videoUrl);

  return (
    <AspectRatio {...rest}>
      <iframe
        title={title}
        src={getVideoUrl(type, videoId, {
          autoplay: autoplay,
          mute: autoplay,
          controls: !autoplay,
        })}
      />
    </AspectRatio>
  );
};
